export enum ActionType {
    EVAL_SEARCH__RELOAD = 'EVAL_SEARCH__RELOAD',
    EVAL_SEARCH__SELECT_USER = 'EVAL_SEARCH__SELECT_USER',
    EVAL_SEARCH__RUN_SEARCH = 'EVAL_SEARCH__RUN_SEARCH',
    EVAL_SEARCH__RUN_SEARCH_RESULT = 'EVAL_SEARCH__RUN_SEARCH_RESULT',
    EVAL_SEARCH__LOAD_MORE = 'EVAL_SEARCH__LOAD_MORE',
    EVAL_SEARCH__SORT_ROWS = 'EVAL_SEARCH__SORT_ROWS',
    EVAL_SEARCH__RESET = 'EVAL_SEARCH__RESET',
}
